import { z } from 'zod/v4'

const pixelIdSchema = z
  .string()
  .trim()
  .max(64)
  .regex(/^\d+$/, 'Enter the numeric Pixel ID from Meta Events Manager.')

export const metaPixelIntegrationSchema = z.object({
  pixel_id: pixelIdSchema,
})

export function normalizeMetaPixelId(value: string | null | undefined): string {
  return String(value ?? '').trim()
}
